import { Grid, Link, Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function ContactPrivacyTerms() {
    const theme = useTheme();

    return (
        <Paper
            elevation={1}
            sx={{ bgcolor: theme.palette.backgroundMainLayout.main, display: 'flex' }}
        >
            <Grid container spacing={2} p={2} flexDirection="column">
                <Grid item>
                    <Typography fontWeight="bold" variant="button">
                        Please confirm Privacy Policy and Consent for Manually-Added or Imported New
                        Leads
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="caption">
                        Various American and Canadian telecommunication regulations place limits on
                        commercial telephone, email, and text messaging contact with leads. Business
                        owners found to be in violation of these regulations face significant fines
                        and penalties. As one example, the Telecommunication Consumer Protection Act
                        orders fines up to $1,500 for each non-compliant telephone call you make.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="caption">
                        Express Consent is especially important for use of personal phone numbers.
                        You <span style={{ fontWeight: 'bold' }}>MUST NOT</span> call or text a lead
                        without dated records of their agreement to receive these messages.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="caption">
                        To protect you, Stay In Contact do not allow you to message any
                        manually-added or imported leads unless you
                        <span style={{ fontWeight: 'bold' }}>
                            {' '}
                            confirm that you have recorded and maintain proof of source and consent
                        </span>
                        .
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="caption">
                        By checking the confirmation boxes on this form, you confirm that you
                        maintain records of (1) instructions or a link to access your Privacy
                        Policy, easily accessible by the lead, indicating how you use their personal
                        information, and (2) the lead's express consent to being contacted via
                        phone, text message, ringless voicemail and/or email, using the personal
                        information they have provided.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="caption">
                        If you are unable to confirm BOTH of these, the lead MAY NOT BE MESSAGED.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="caption" fontWeight="bold">
                        Please DO NOT simply check these boxes to enable messaging for unconfirmed
                        leads. By checking the boxes, you agree to accept responsibility for
                        non-compliant communication practices.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="caption">
                        In any event, the
                        <Link
                            href="https://stayincontact.com/eula/"
                            target="_blank"
                            rel="noopener"
                            underline="hover"
                            variant="body2"
                        >
                            &nbsp;Stay In Contact EULA and Terms
                        </Link>{' '}
                        govern use of all ConsulNet products, including Stay In Contact, including
                        the Indemnity & Release terms with respect to any consequences of your
                        violating applicable regulations for telephone, email, ringless voicemail
                        and/or text messaging sent to leads of any type.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="caption">
                        <span style={{ fontWeight: 'bold' }}>This is NOT legal advice.</span> Please
                        consult your own legal representation to review and confirm your
                        understanding of all applicable laws and regulations.
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}
